import Collection from "thexternal/collection";

export { Collection };

customElements.define(
  "thexternal-collection",
  Collection.CustomElementConstructor
);
